import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Grid, FormControl, FormHelperText } from '@mui/material';
import { Usuario } from '../../types/usuario/Usuario'; // Certifique-se de importar o tipo Usuario
import { useState } from 'react';
import { validarSenhaForte } from '../../utils/validarSenhaForte';

interface ChangePasswordDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (newPassword: string, oldPassword: string) => void;
  usuario: Usuario | null;
  isAdminArea: boolean;
}

export const ChangePasswordDialog = ({ open, onClose, onConfirm, usuario, isAdminArea }: ChangePasswordDialogProps) => {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmaSenha, setConfirmaSenha] = useState('');

  // Função para validar senha forte (pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas, números e caracteres especiais)

  const handleSenhaAtualChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSenhaAtual(e.target.value);
  };

  const handleNovaSenhaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNovaSenha(e.target.value);
  };

  const handleConfirmaSenhaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmaSenha(e.target.value);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Alterar Senha de {usuario?.nome}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {/* Senha Atual */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="Senha Atual"
                name="senhaAtual"
                type="password"
                onChange={handleSenhaAtualChange}
                size="small"
                value={senhaAtual}
                error={senhaAtual === ''}
                helperText={senhaAtual === '' ? 'Informe a senha':  isAdminArea ? 'Informe a senha do Administrador que está logado no sistema ' : 'Informe a Senha atual do usuário que deseja alterar'}
              />
            </FormControl>
          </Grid>

          {/* Nova Senha */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="Nova Senha"
                name="novaSenha"
                type="password"
                onChange={handleNovaSenhaChange}
                size="small"
                value={novaSenha}
                error={novaSenha !== confirmaSenha || (!!novaSenha && !validarSenhaForte(novaSenha))}
                helperText={
                  novaSenha && !validarSenhaForte(novaSenha)
                    ? 'Senha fraca: mínimo 8 caracteres, incluindo maiúscula, minúscula, número e caractere especial'
                    : `${novaSenha?.length || 0}/100 caracteres`
                }
              />
            </FormControl>
          </Grid>

          {/* Confirmar Senha */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="Confirmar Senha"
                name="confirmaSenha"
                type="password"
                onChange={handleConfirmaSenhaChange}
                size="small"
                value={confirmaSenha}
                error={novaSenha !== confirmaSenha}
                helperText={novaSenha !== confirmaSenha ? 'As senhas não coincidem' : `${confirmaSenha?.length || 0}/100 caracteres`}
              />
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={() => {
            if (novaSenha === confirmaSenha && validarSenhaForte(novaSenha)) {
              onConfirm(novaSenha, senhaAtual);
              setSenhaAtual('');
              setNovaSenha('');
              setConfirmaSenha('');
            }
          }}
          color="primary"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
